import { extractRenderParts } from './helpers';
import type { AutocompleteListProps } from './types';

export const AutocompleteList = <TItem,>({
  renderItems,
  hasFurtherMessage,
  highlightedIndex,
  styleList,
  getItemKey,
  getItemValue,
  renderItem,
  renderFurtherMessageItem,
  renderNoResults,
  onSelect,
  onHighlight,
}: AutocompleteListProps<TItem>) => {
  return (
    <ul style={styleList} className="absolute left-0 w-full m-0 p-0 list-none bg-white">
      {renderItems.length
        ? renderItems.map((item, index) => {
            const isHighlighted = highlightedIndex === index;
            const key = `item-${getItemKey(item)}`;
            const { node, skipClickEvent } = extractRenderParts(renderItem(item, isHighlighted, index, key));

            return (
              <li
                key={key}
                onMouseDown={() => {
                  requestAnimationFrame(() => {
                    if (!skipClickEvent) {
                      onSelect(getItemValue(item));
                    }
                  });
                }}
                onMouseEnter={() => onHighlight(index)}
              >
                {node}
              </li>
            );
          })
        : renderNoResults()}

      {hasFurtherMessage ? (
        <li
          key="~~--furthermessage--~~"
          onMouseDown={() => {
            requestAnimationFrame(() => {
              onSelect(undefined, true);
            });
          }}
          onMouseEnter={() => onHighlight(renderItems.length)}
        >
          {renderFurtherMessageItem(renderItems.length === highlightedIndex)}
        </li>
      ) : null}
    </ul>
  );
};
